import {throttle, changeUrlState } from '../utils';
import { PAGINATION_LOAD_MORE } from '../constEvents';

import ee from './eventemitter';
import API from './api';
import ToggleBtn from './toggleBtn';
import Pagination from './pagintation';

export default class Filter {
    constructor ({ $node }) {
        this.$wrapper = $node;

        this.$filterForm = $node.find('.js-filter-form');

        // this.$tagsContainer = this.$filterForm.find('.js-filter-tags-container');
        // this.$tagsInputs = this.$tagsContainer.find('input');

        this.$pageFormField = this.$filterForm.find('.js-form-page');
        this.$itemsContainer = this.$wrapper.find('.js-filter-items');

        this.API = new API();

        this.pagination = new Pagination({
            contentContainer: this.$wrapper
        });
    }

    _getPaginationTemplate() {
        return $(`<section class="section">
                    <div class="section__body">
                      <div class="pagination">
                        <a href="#" class="btn btn_full-width pagination__load-more">Показать еще статьи</a>
                      </div>
                    </div>
                  </section>`
        );
    }

    _formSubmitHandler = args => {
        const $form = this.$filterForm;
        const url = $form.attr('action');
        let data = $form.serialize();

        if (args && args.nextPage) data = data + `&next_page=${args.nextPage}`;

        return this.API.get({
            method: 'get',
            data,
            url,
            loaderContainer: this.$wrapper
        }).then(res => {
            const { html, page, next } = res;

            if (html) {
                changeUrlState({
                    search: '?' + data
                });
            } else {
                //show error
            }

            this.$pageFormField.val(page);

            if (!next) {
                this.pagination.destroy();
            } else {
                if (!this.$wrapper.find('.pagination').length) {
                    this.$wrapper.append(this._getPaginationTemplate());
                }
            }

            return res;
        });
    };

    resetForm = e => {
        e && e.preventDefault && e.preventDefault();

        this.$filterForm.trigger('reset');
        this.$filterForm.trigger('submit');
    };

    _formBehavior() {
        const $form = this.$filterForm;

        ee.on(PAGINATION_LOAD_MORE, () => {
            const pageNumber = Number(this.$pageFormField.val()) || 1;
            this.$pageFormField.val(pageNumber);

            this._formSubmitHandler({
                nextPage: pageNumber + 1
            }).then(({ html }) => {
                this.$itemsContainer.append(html);
            });
        });

        $form.on('change', throttle(() => {
            $form.trigger('submit');
        }));

        $form.submit(() => {
            this._formSubmitHandler().then(({ html }) => {
                this.$itemsContainer.html(html);
            });

            return false;
        });
    }

    _buildToggleBtns() {
        const $toggleListBtn = this.$filterForm.find('.js-toggle-tag-list');
        const toggleElementClass = $toggleListBtn.data('toggle-element-class');

        if (!$toggleListBtn.length) return;

        new ToggleBtn({
            triggerElement: $toggleListBtn,
            toggleElement: $(`.${toggleElementClass}`)
        }).init();
    }

    _bindHandlers() {
        this.$pageFormField.change(() => false);
        this.$filterForm.on('click', '.js-toggle-reset', this.resetForm);
    }

    init() {
        this._buildToggleBtns();
        this._bindHandlers();

        // навешимаем обработчики после обновления состояния
        this._formBehavior();
    }
}



// WEBPACK FOOTER //
// ./components/filter.js